package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File

@Composable
fun FileInput(
    onFileSelected: (File) -> Unit,
    refCallback: (HTMLInputElement) -> Unit
) {
    Input(
        type = InputType.File,
        attrs = {
            style {
                display(DisplayStyle.None)
            }
            attr("accept", "image/*")

            onChange { event ->
                val element = event.target

                event.target.files?.item(0)?.let { file ->
                    onFileSelected(file)
                }
            }
            ref { element ->
                refCallback(element)
                onDispose {}
            }
        }
    )
}